import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import ColourFilterBox from "../../../../components/FilterBox/ColourFilter/ColourFilter";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import ColourTable from "../../../../components/Tables/ColourTable";
import { FiMenu } from "react-icons/fi";

import { format } from "date-fns";

import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import {
  ColourFilter,
  ProductionTUCTable,
  ProductionTUCTableFun,
} from "../../../../Redux/Slice/Colour/InwardAnylysis/InwardAnylysis";
import { Loader } from "../../../../components/Loader/Loader";
import Calendar from "react-calendar";
import { useTheme } from "../../../../Themecontext/Themecontext";
import ColorCalenderCss from "../../../../components/Calendar/ColorCalenderCss";

export const MasterWiseCosting = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { ColourfilterData, ProductionTUCDataTable } = useSelector(
    (state) => state.InwardAnylysisSlice,
  );

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICL",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const FinancialYear = Cookies.get("FinancialYear");

  // 🔹 Offcanvas State
  const [showFilter, setShowFilter] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };

  useEffect(() => {
    dispatch(ColourFilter());

    dispatch(
      ProductionTUCTable({
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
        ProductionGroupIDs: filter.productionGroup.join(","),
      }),
    );
  }, [dispatch, startDate, endDate]);
  // 🔹 Dummy Filter Data
  const productionGroupList = ColourfilterData?.ProductionGroup?.map(
    (item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    }),
  );

  const [filter, setFilter] = useState({
    productionGroup: [],
  });

  const [search, setSearch] = useState({
    productionGroup: "",
  });
  const columns = [
    {
      label: "Sr. No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Production Group",
      key: "ProductionGroupMstName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Today Production Meter",
      key: "TodayMeter",
      align: "right",
      format: "true",
    },
    {
      label: "Today Cost Amount",
      key: "ToDayCostAmount",
      align: "right",
      format: "true",
    },
    {
      label: "Today Per Meter Cost",
      key: "TodayPMeterCost",
      align: "right",
      format: "true",
    },
    { label: "Upto Meter", key: "UptoMeter", align: "right", format: "true" },
    {
      label: "Upto Cost Amount",
      key: "UptoCostAmount",
      align: "right",
      format: "true",
    },
    { label: "Upto Per Meter Cost", key: "UptoPMeterCost", align: "right" },
  ];

  const initialData = (ProductionTUCDataTable?.Data || []).map(
    (row, index, arr) => ({
      ProductionGroupMstName: row.ProductionGroupMstName || "",
      TodayMeter: row.TodayMeter || 0,
      ToDayCostAmount: row.ToDayCostAmount || 0,
      TodayPMeterCost: row.TodayPMeterCost || 0,
      UptoMeter: row.UptoMeter || 0,
      UptoCostAmount: row.UptoCostAmount || 0,
      UptoPMeterCost: row.UptoPMeterCost || 0,
    }),
  );

  // 🔹 Filter Logic
  const toggleItem = (type, item) => {
    setFilter((prev) => {
      let newSelected = [];

      if (type === "productionGroup") {
        if (prev[type].includes(item.value)) {
          newSelected = prev[type].filter((id) => id !== item.value);
        } else {
          newSelected = [...prev[type], item.value];
        }
        dispatch(ProductionTUCTableFun());
        dispatch(
          ProductionTUCTable({
            StartDate: safeFormat(startDate),
            EndDate: safeFormat(endDate),
            ProductionGroupIDs: newSelected.join(","),
          }),
        );
      }

      return {
        ...prev,
        [type]: newSelected,
      };
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);
    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  if (!ColourfilterData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!ProductionTUCDataTable || ProductionTUCDataTable === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        minHeight: "100vh",
        padding: "16px",
      }}
    >
      <Row>
        {/* 🔷 Mobile Filter Button */}
        <Col xs={12} className="d-lg-none text-end mb-2">
          <Button
            onClick={() => setShowFilter(true)}
            style={{
              background:
                isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
              border: "none",
            }}
          >
            <FiMenu />
          </Button>
        </Col>

        {/* 🔷 Desktop Filter */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <div >
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour7,
                  padding: "13px 20px",
                  borderRadius: "12px 12px 0px 0px",
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    margin: 0,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour12,
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  {" "}
                  Date Range
                </h3>
              </div>
              <div
                style={{
                  border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                  padding: "15px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour3,
                  borderRadius: "0px 0px 12px 12px",
                }}
              >
                <div
                  onClick={() => setShowDatePicker(true)}
                  style={{
                    marginTop: "8px",
                    padding: "10px",
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    borderRadius: "10px",
                    cursor: "pointer",
                    textAlign: "center",
                    color: isdark === "light" ? "#000" : "#fff",
                  }}
                >
                  {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? `${format(dateRange[0].startDate, "dd/MM/yyyy")} - ${format(dateRange[0].endDate, "dd/MM/yyyy")}`
                    : "Select Date Range"}
                </div>
              </div>
            </div>
            <ColourFilterBox
              title="productionGroup"
              items={productionGroupList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filter.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() => selectAll("productionGroup", productionGroupList)}
            />
          </div>
        </Col>

        {/* 🔷 Offcanvas Filter */}
        <Offcanvas show={showFilter} onHide={() => setShowFilter(false)}
          style={{
            background:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
          }}
        >
          <Offcanvas.Header closeButton
            closeVariant={isdark === "dark" ? "white" : undefined}
            style={{ color: isdark === "light" ? "#000" : "#FFF", }} >
            <Offcanvas.Title>Filters</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <div  >
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour7,
                    padding: "13px 20px",
                    borderRadius: "12px 12px 0px 0px",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      margin: 0,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour12,
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    {" "}
                    Date Range
                  </h3>
                </div>
                <div
                  style={{
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    padding: "15px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour3,
                    borderRadius: "0px 0px 12px 12px",
                  }}
                >
                  <div
                    onClick={() => setShowDatePicker(true)}
                    style={{
                      marginTop: "8px",
                      padding: "10px",
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                      borderRadius: "10px",
                      cursor: "pointer",
                      textAlign: "center",
                      color: isdark === "light" ? "#000" : "#fff",
                    }}
                  >
                    {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                      ? `${format(dateRange[0].startDate, "dd/MM/yyyy")} - ${format(dateRange[0].endDate, "dd/MM/yyyy")}`
                      : "Select Date Range"}
                  </div>
                </div>
              </div>
              <ColourFilterBox
                title="productionGroup"
                items={productionGroupList}
                search={search.productionGroup}
                setSearch={(val) => handleSearch("productionGroup", val)}
                selectedItems={filter.productionGroup}
                toggleItem={(item) => toggleItem("productionGroup", item)}
                selectAll={() =>
                  selectAll("productionGroup", productionGroupList)
                }
              />

            </div>


          </Offcanvas.Body>
        </Offcanvas>

        {/* 🔷 Table Section */}
        <Col xl={9} lg={8}>
          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "17px",
                letterSpacing: "1px",
                fontSize: "18px"
              }}
            >
              MASTERWISE COSTING DETAIL
            </div>

            <ColourTable columns={columns} data={initialData} />
          </div>
        </Col>
      </Row>
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <ColorCalenderCss
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour7
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MasterWiseCosting;
